import { Divider, Stack, Text } from "@mantine/core";
import { useComposeFormContext } from "shared/components/message/compose/context";
import { UserPicker } from "shared/components/user/UserPicker";
import { useFormState } from "shared/hooks/useFormState";
import { usePermissionCheck } from "shared/stores/oidc";
import { Permission } from "src/gql/graphql";

export const AudienceUserEditor = () => {
    const form = useComposeFormContext();
    const [initialValue, setUsers] = useFormState(form, "audience.users");
    const hasGroupUserView = usePermissionCheck(Permission.GroupUsersView);
    const hasTopicUserView = usePermissionCheck(Permission.TopicCategoryManage);

    if (!hasGroupUserView && !hasTopicUserView) return null;

    return (
        <>
            <Stack>
                <div>
                    <Text fw="bold">Users</Text>
                    <Text size="xs" c="dimmed">
                        Send to individual users.
                    </Text>
                </div>
                <UserPicker initialValue={initialValue} onSelectionChange={setUsers} />
            </Stack>
            <Divider />
        </>
    );
};
